import React from 'react';
import { DutyCheck } from '../../types/shared';
import { dutySlots, slotState, SlotState, slotStateLabels } from '../../utils/duties';
const dotCls: Record<SlotState, string> = {
  urejeno: 'bg-done text-white',
  popravljeno: 'bg-done text-white',
  'ni-urejeno': 'bg-accent text-white',
  odprto: 'border-2 border-dashed border-[#C9BBA4] text-muted',
  izpadlo: 'bg-line text-muted'
};

/** Trije tedenski pregledi (pon, sre, sob) kot pike s kratico dneva. */
export function DutyDots({
  checks
}: {
  checks: DutyCheck[];
}) {
  return <ul className="flex gap-1.5" aria-label="Pregledi ta teden" data-id="element-118" data-mp="1z3b37owvrqxc">
      {dutySlots.map(s => {
      const state = slotState(checks.find(c => c.slot === s.slot), s.date);
      return <li key={s.slot} title={`${s.short}: ${slotStateLabels[state]}`} className={`grid h-7 min-w-[2.5rem] place-items-center rounded-full px-2 text-[11px] font-extrabold ${dotCls[state]}`} data-id="element-119" data-mp="290xu79rgf8xo">
            <span aria-hidden="true" data-id="element-120" data-mp="urzv0pquajt3">{s.short}</span>
            <span className="sr-only" data-id="element-121" data-mp="usswbb714h3u">
              {s.label}: {slotStateLabels[state]}
            </span>
          </li>;
    })}
    </ul>;
}